module.exports = __webpack_public_path__ + "static/media/5.8a15cf8d.jpeg";